// import { AuthRole } from '../app/auth/+state/auth.interface';

// openid configuration url:
// https://ishgroupb2c.b2clogin.com/ishgroupb2c.onmicrosoft.com/B2C_1A_SuSi_MSADCommon/v2.0/.well-known/openid-configuration

const AzureTenant = 'ishgroupb2c';
const AzureUserFlow = 'B2C_1A_SuSi_MSADCommon';
const AzureAppClientId = '688b738c-13f0-4f40-952e-7eae48bea5f7';
/*'2cd24ff2-5c80-452f-9041-d5c8da1ff9c3';*/
interface BaseEnvironment {
  auth: {
    authority: string;
    clientId: string;
    apiKey: string;
    uri: {
      authorize: string;
      token: string;
      logout: string;
      redirect: string;
    };
    apiScopes: {
      base: string[];
      avsApi: string;
    };
    exceptions: {
      avs: string[];
    };
  };
  // allowedRoles: AuthRole[];
}

export interface Environment extends BaseEnvironment {
  production: boolean;
  development: boolean;
  api: {
    avs: string;
  };
}

export const baseEnv: BaseEnvironment = {
  auth: {
    authority: `https://${AzureTenant}.b2clogin.com/${AzureTenant}.onmicrosoft.com/${AzureUserFlow}`,
    clientId: AzureAppClientId,
    apiKey: 'dev-123456789-do-not-use-in-production',
    uri: {
      authorize: `https://${AzureTenant}.b2clogin.com/${AzureTenant}.onmicrosoft.com/${AzureUserFlow}/oauth2/v2.0/authorize`,
      token: `https://${AzureTenant}.b2clogin.com/${AzureTenant}.onmicrosoft.com/${AzureUserFlow}/oauth2/v2.0/token`,
      logout: `https://${AzureTenant}.b2clogin.com/${AzureTenant}.onmicrosoft.com/${AzureUserFlow}/oauth2/v2.0/logout`,
      redirect: '/auth/callback',
    },
    apiScopes: {
      base: ['openid', 'offline_access'],
      // base: [`${AzureAppClientId}/.default`, 'openid', 'offline_access'],
      avsApi: `https://${AzureTenant}.onmicrosoft.com/avsapi/user_impersonation`,
    },
    // exceptions for routes of the APIs which do not require an auth header
    exceptions: { avs: [] },
  },
  // allowedRoles: [AuthRole.Mitarbeiter, AuthRole.Gastreferent],
};
